<div class="timeoff-dialog">
  
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>{{ data.timeOff ? 'edit' : 'add' }}</mat-icon>
      {{ data.timeOff ? 'Editar ausencia' : 'Añadir ausencia' }}
    </h2>
    <button mat-icon-button mat-dialog-close class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <form [formGroup]="timeOffForm" class="timeoff-form">

      <div class="row mb-3">
        <div class="col-md-12">
          <div class="info-box">
            <mat-icon>person</mat-icon>
            <span>{{ data.staffName }}</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Inicio</mat-label>
            <input matInput [matDatepicker]="pickerStart" formControlName="startAt" required>
            <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
            <mat-error *ngIf="timeOffForm.get('startAt').hasError('required')">
              La fecha de inicio es obligatoria
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fin</mat-label>
            <input matInput [matDatepicker]="pickerEnd" formControlName="endAt" required>
            <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
            <mat-error *ngIf="timeOffForm.get('endAt').hasError('required')">
              La fecha de fin es obligatoria
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Motivo</mat-label>
            <textarea matInput formControlName="reason" rows="3" 
                      placeholder="Vacaciones, baja médica, formación, etc."></textarea>
            <mat-hint align="end">{{ timeOffForm.get('reason').value?.length || 0 }}/500</mat-hint>
            <mat-error *ngIf="timeOffForm.get('reason').hasError('maxlength')">
              Máximo 500 caracteres
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="duration-info" *ngIf="timeOffForm.get('startAt').value && timeOffForm.get('endAt').value">
        <mat-icon>info</mat-icon>
        <span>Duración: {{ calculateDuration() }}</span>
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <app-button
      label="Cancelar"
      icon="close"
      variant="secondary"
      mat-dialog-close>
    </app-button>
    <app-button 
      [label]="data.timeOff ? 'Guardar cambios' : 'Añadir ausencia'"
      icon="save" 
      variant="primary" 
      [disabled]="timeOffForm.invalid"
      (click)="onSave()">
    </app-button>
  </mat-dialog-actions>

</div>
